import { backgroundOrange, blue, blueDark, border1, border2, textMuted, white } from '@/theme/colors'
import { fontBody, fontDisplay } from '@/theme/fonts'
import { contentShell } from '@/theme/layout'
import { breakpoints, radii } from '@/theme/tokens'
import styled from 'styled-components'

/* Full-bleed sticky bar: background/border span the viewport and the vertical
   padding (incl. the notch inset) lives here; the horizontal gutter and the
   brand↔actions row move to HeaderInner (the shared contentShell) so the brand
   lines up with the centered page content below. */
export const HeaderBar = styled.header`
	position: sticky;
	top: 0;
	z-index: 40;
	padding: 16px 0;
	/* Clear the notch / status bar when the page is viewed full-bleed on a phone. */
	padding-top: max(16px, env(safe-area-inset-top));
	background: ${backgroundOrange};
	border-bottom: 1px solid ${border1};

	@media (max-width: ${breakpoints.bentoCollapse}px) {
		padding: 14px 0;
		padding-top: max(14px, env(safe-area-inset-top));
	}

	@media (max-width: ${breakpoints.phone}px) {
		padding: 10px 0;
		padding-top: max(10px, env(safe-area-inset-top));
	}
`

export const HeaderInner = styled.div`
	${contentShell}
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 12px;

	@media (max-width: ${breakpoints.phone}px) {
		gap: 8px;
	}
`

/** Link wrapper only — the lockup itself is the shared @components/BrandMark. */
export const Brand = styled.a`
	display: inline-flex;
	align-items: center;
	text-decoration: none;
`

export const HeaderRight = styled.div`
	display: flex;
	align-items: center;
	gap: 14px;

	@media (max-width: ${breakpoints.phone}px) {
		gap: 8px;
	}
`

export const ReadOnlyPill = styled.span`
	display: inline-flex;
	align-items: center;
	gap: 6px;
	font-family: ${fontBody};
	font-size: 13px;
	color: ${textMuted};
	background: transparent;
	border: 1px solid ${border2};
	border-radius: ${radii.pill};
	padding: 6px 12px;
	white-space: nowrap;

	/* Compact on phones (the "Shared trip · " prefix drops) — kept, not hidden. */
	@media (max-width: ${breakpoints.phone}px) {
		gap: 5px;
		font-size: 11.5px;
		padding: 4px 9px;
	}
`

/** The "Shared trip · " lead-in — dropped on phones so only "view only" shows. */
export const PillPrefix = styled.span`
	@media (max-width: ${breakpoints.phone}px) {
		display: none;
	}
`

export const CtaButton = styled.a`
	font-family: ${fontDisplay};
	font-weight: 700;
	font-size: 14px;
	color: ${white};
	background: ${blue};
	border: none;
	border-radius: 14px;
	padding: 10px 18px;
	text-decoration: none;
	cursor: pointer;
	white-space: nowrap;
	transition:
		background 0.2s ease-out,
		transform 0.12s ease-out;

	&:hover {
		background: ${blueDark};
	}

	&:active {
		transform: scale(0.97);
	}

	@media (prefers-reduced-motion: reduce) {
		transition: none;
	}

	/* Small CTA per the mobile handoff (12px radius, tighter). */
	@media (max-width: ${breakpoints.phone}px) {
		font-size: 13px;
		padding: 8px 13px;
		border-radius: 12px;
	}
`
